<template>
  <div v-if="collectionDocument" class="home collection">
    <blocks
      v-if="collectionDocument.blocks"
      :blocks="collectionDocument.blocks"
      :origin="ORIGIN.HOME"
      :entities="{ collection: collectionDocument }"
      is-home
      is-on-top-of-page
    />
  </div>
</template>

<script>
import ScrollTrackingMixin from '@/mixins/ScrollTrackingMixin'
import Blocks from '@/components/blocks/Blocks'

import services from '@/services'

import { ORIGIN } from '@/const'

export default {
  name: 'HomeContext',
  components: {
    Blocks,
  },
  mixins: [ScrollTrackingMixin],
  async asyncData({ payload, $logError, i18n, error, params }) {
    if (payload && payload.collectionDocument) {
      return {
        collectionDocument: payload.collectionDocument,
      }
    }

    try {
      // Query to get post content
      const collectionDocument = await services.sanityService
        .getHome({
          context: params.context,
          lang: i18n.locale.slice(0, 2),
        })
        .then((res) => {
          if (res.length > 0) {
            return res[0]
          }

          return null
        })

      if (!collectionDocument) {
        throw new Error('home-not-found')
      }

      // Returns data to be used in template
      return {
        collectionDocument,
      }
    } catch (e) {
      // Returns error page
      $logError.captureException(e, {
        uid: `home-${params.context}`,
        lang: i18n.locale,
        tags: {
          page: 'home',
        },
      })
      error({
        statusCode: 404,
        message: `Collection home-${params.context} not found for ${i18n.locale}`,
      })
    }
  },
  data: () => ({
    collectionDocument: null,
    products: [],
    ORIGIN,
  }),
  head() {
    if (this.collectionDocument) {
      const route = `${
        process.env.BASE_URL ? process.env.BASE_URL : 'https://www.asphalte.com'
      }${this.$nuxt.$route.path}`

      const head = services.pageService.getHead(
        {
          type: 'home',
          title: this.collectionDocument.title,
          route,
          sanity: this.collectionDocument,
          defaultTitle: this.$t('seo.defaultTitle'),
          defaultDesc: this.$t('seo.defaultDesc'),
        },
        this.$generateAlternateLinksMetaSanity(
          this.collectionDocument._type,
          this.collectionDocument.alternate_languages
        )
      )

      head.bodyAttrs = {
        class: 'home header-transparent',
      }

      return head
    }

    return {
      bodyAttrs: {
        class: 'home header-transparent',
      },
    }
  },
  mounted() {
    this.$track.page(this.$metaInfo, this.$route, this.$nuxt.context.from)
  },
}
</script>
